import { WidgetVersionController } from 'widgets/WidgetVersionManager/WidgetVersionManager.types';

// the latest version of the widget
export const VERSION = 1;

// Add VersionControllers here that implement the WidgetVersionController interface
export const funnelChartWidgetVersionControllers: WidgetVersionController[] = [];
